import { WidgetSchema } from 'features/views/LayoutEditor/types'

import { PipelineWidget, PipelineWidgetAdminControls } from './PipelineWidget'
import { PipelineWidgetType } from './types'
import { getAvailableStages, getSupportedFields } from './utils'

export const PipelineWidgetMeta: WidgetSchema<PipelineWidgetType> = {
    category: 'data',
    label: 'Pipeline',
    icon: 'Merge',
    component: PipelineWidget,
    adminControlsComponent: PipelineWidgetAdminControls,
    defaultAttrs: ({ fields = [] }) => {
        const defaultAttrs: PipelineWidgetType['attrs'] = {
            style: 'horizontal',
            stages: [],
            isReadOnly: false,
            mode: 'default',
        }

        const supportedFields = getSupportedFields(fields)
        const defaultField = supportedFields[0]
        if (!defaultField) return defaultAttrs

        const defaultStages = getAvailableStages(defaultAttrs, new Map(), defaultField).map(
            (s) => ({ ...s.stage, isActive: true })
        )

        return {
            ...defaultAttrs,
            field: { type: 'field', fieldApiName: defaultField.api_name },
            stages: defaultStages,
        }
    },
    requireFields: (attrs) => {
        const fields: string[] = []

        const fieldApiName = attrs.field?.fieldApiName
        if (fieldApiName) fields.push(fieldApiName)

        for (const stage of attrs.stages ?? []) {
            if (typeof stage.description === 'string') continue
            fields.push(stage.description.fieldApiName)
        }

        return fields
    },
}
